var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "vks-viewport-controls",
      attrs: { role: "toolbar", "aria-label": "Canvas controls" },
    },
    [
      _c("div", { staticClass: "vks-zoom-group" }, [
        _c(
          "label",
          { staticClass: "vks-zoom-label", attrs: { for: _vm.zoomInputId } },
          [_vm._v("Region zoom")]
        ),
        _c("div", { staticClass: "vks-zoom-slider-slot" }, [
          _c(
            "div",
            {
              staticClass: "vks-zoom-slider-shell",
              class: {
                "is-zoom-out-limit": _vm.zoomOutAtLimit,
                "is-zoom-out-active": _vm.localSlider < 0,
                "is-zoom-in-active": _vm.localSlider > 0,
                "is-dragging": _vm.isDragging,
              },
            },
            [
              _c(
                "div",
                {
                  staticClass: "vks-zoom-slider-track",
                  attrs: { "aria-hidden": "true" },
                },
                [
                  _c("div", {
                    staticClass:
                      "vks-zoom-slider-fill vks-zoom-slider-fill--out",
                    style: _vm.zoomOutFillStyle,
                  }),
                  _c("div", {
                    staticClass:
                      "vks-zoom-slider-fill vks-zoom-slider-fill--in",
                    style: _vm.zoomInFillStyle,
                  }),
                ]
              ),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model.number",
                    value: _vm.localSlider,
                    expression: "localSlider",
                    modifiers: { number: true },
                  },
                ],
                staticClass: "vks-zoom-slider",
                attrs: {
                  id: _vm.zoomInputId,
                  type: "range",
                  min: _vm.sliderMin,
                  max: _vm.sliderMax,
                  step: 1,
                  "aria-valuetext": _vm.zoomHandleLabel,
                  "aria-label": "Region zoom",
                },
                domProps: { value: _vm.localSlider },
                on: {
                  pointerdown: _vm.onZoomPointerDown,
                  input: _vm.onZoomInput,
                  change: _vm.onZoomCommit,
                  __r: function ($event) {
                    _vm.localSlider = _vm._n($event.target.value)
                  },
                  blur: function ($event) {
                    return _vm.$forceUpdate()
                  },
                },
              }),
              _c(
                "div",
                {
                  staticClass: "vks-zoom-slider-thumb",
                  style: _vm.thumbStyle,
                  attrs: { "aria-hidden": "true" },
                },
                [_vm._v(" " + _vm._s(_vm.zoomHandleLabel) + " ")]
              ),
            ]
          ),
        ]),
      ]),
      _c("div", { staticClass: "vks-viewport-actions" }, [
        _c(
          "button",
          {
            staticClass: "vks-control-btn",
            class: { "is-active": _vm.dataTableOpen },
            attrs: {
              type: "button",
              title: "Variant data table",
              "aria-label": "Variant data table",
              "aria-expanded": _vm.dataTableOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("update:dataTableOpen", !_vm.dataTableOpen)
              },
            },
          },
          [_c("b-icon", { attrs: { icon: "table", "aria-hidden": "true" } })],
          1
        ),
        _c(
          "button",
          {
            staticClass: "vks-control-btn vks-control-btn--assistant",
            class: { "is-active": _vm.aiAssistantOpen },
            attrs: {
              type: "button",
              title: "Variant Sifter actions",
              "aria-label": "Variant Sifter actions",
              "aria-expanded": _vm.aiAssistantOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-assistant")
              },
            },
          },
          [
            _c(
              "span",
              {
                staticClass: "vks-control-ai-label",
                attrs: { "aria-hidden": "true" },
              },
              [_vm._v("Actions")]
            ),
          ]
        ),
        _c(
          "button",
          {
            staticClass: "vks-control-btn",
            class: { "is-active": _vm.settingsOpen },
            attrs: {
              type: "button",
              title: "Settings",
              "aria-label": "Settings",
              "aria-expanded": _vm.settingsOpen ? "true" : "false",
            },
            on: {
              click: function ($event) {
                return _vm.$emit("toggle-settings")
              },
            },
          },
          [
            _c("b-icon", {
              attrs: { icon: "gear-fill", "aria-hidden": "true" },
            }),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }